var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVaccinechart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "store-detail"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17 2C17 2.51 17 2.765 17.068 3.002C17.1053 3.13267 17.157 3.25767 17.223 3.377C17.343 3.593 17.523 3.773 17.883 4.134L19.866 6.116C20.226 6.476 20.406 6.656 20.623 6.777C20.7417 6.84367 20.8667 6.89533 20.998 6.932C21.235 7 21.49 7 22 7M11.693 7L6.765 11.928C5.7 12.993 5.168 13.525 5.041 14.163C4.986 14.439 4.986 14.723 5.041 15C5.168 15.638 5.701 16.17 6.765 17.235C7.829 18.3 8.362 18.832 9 18.959C9.277 19.014 9.56 19.014 9.837 18.959C10.475 18.832 11.007 18.299 12.072 17.235L17 12.307M11 6L18 13M8 18.637L6.83 19.472C6.36 19.809 6.125 19.977 5.866 19.997C5.766 20.005 5.66667 19.9967 5.568 19.972C5.317 19.91 5.113 19.705 4.704 19.297C4.294 18.887 4.09 18.683 4.028 18.432C4.00478 18.3345 3.99635 18.234 4.003 18.134C4.023 17.875 4.191 17.64 4.527 17.169L5.363 16M13.5 8L18.5 4M16 10.5L20 5.5M4.5 19.5L2 22",
    stroke: "#FDBF26",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaccinechart);
export default __webpack_public_path__ + "static/media/vaccinechart.9faa0ee151166f8bc2cf998f15b52d34.svg";
export { ForwardRef as ReactComponent };